var allCities = [
    {
      "Departamento": "Antioquia",
      "CodeZip": "ANT",
      "Municipio": ["Medellín"]
    },
    {
      "Departamento": "Bogotá, D.C.",
      "CodeZip": "DC",
      "Municipio": ["Bogotá"]
    },
    {
      "Departamento": "Valle del Cauca",
      "CodeZip": "VAC",
      "Municipio": ["Cali"]
    }, 
    {
      "Departamento": "Atlántico",
      "CodeZip": "ATL",
      "Municipio": ["Barranquilla"]
    }
  ]
  